<template>
  <div
    class="rs-pill"
    :class="statusClasses"
    @click="$emit('click')"
  >
    <span>{{ title }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPill',
  props: {
    /**
        * Color variants: default | primary color | secondary | success | warning | error | info | dark | light | dusty-blue | mustard-yellow
        */
    variant: {
      type: String,
      default: 'default',
    },
    title: String,
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusClasses() {
      return {
        'rs-pill--selected': this.selected,
        'rs-pill--default': this.variant === 'default',
        'rs-pill--primary': this.variant === 'primary',
        'rs-pill--secondary': this.variant === 'secondary',
        'rs-pill--secondary-dark': this.variant === 'secondary-dark',
        'rs-pill--success': this.variant === 'success',
        'rs-pill--warning': this.variant === 'warning',
        'rs-pill--warning-toast': this.variant === 'warning-toast',
        'rs-pill--error': this.variant === 'error',
        'rs-pill--info': this.variant === 'info',
        'rs-pill--dusty-blue': this.variant === 'dusty-blue',
        'rs-pill--mustard-yellow': this.variant === 'mustard-yellow',
        'rs-pill--light': this.variant === 'light',
        'rs-pill--dark': this.variant === 'dark',
        'rs-pill--security': this.variant === 'security',
        'rs-pill--plumbing': this.variant === 'plumbing',
        'rs-pill--heating': this.variant === 'heating',
        'rs-pill--electrical': this.variant === 'electrical',
        'rs-pill--neon-yellow': this.variant === 'neon-yellow',
        'rs-pill--green': this.variant === 'green',
        'rs-pill--red': this.variant === 'red',
        'rs-pill--blue': this.variant === 'blue',
      };
    },
  },

});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';
  .rs-pill{
    display: inline-block;
    border-radius: 6px;
    padding: 0 1rem;
    line-height: 29px;
    color: $tertiary-muted;
    background-color: $white;
    font-weight: bold;
    align-items: center;
    text-align: center;
    span{
      font-size: 0.875rem;
      position: relative;
      // padding-left: 12px;
      /* &:before{
        content: '';
        position: absolute;
        display: inline-block;
        margin-top: -1px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: $tertiary-muted;
      } */
    }
    @each $name, $color in $colors {
      &--#{$name} {
        border: none;
        color: $color;
        background-color: rgba($color, 0.25);
        /* span{
          &:before{
            background-color: $color;
          }
        } */
      }
    }
    &--default{
      border: 1px solid $extra-light-gray;
    }
    &--dusty-blue {
      color: $dusty-blue;
      background-color: $dusty-blue-light;
    }
    &--mustard-yellow {
      color: $mustard-yellow;
      background-color: $mustard-yellow-light;
    }
    &--selected{
      color: $white;
      border-color: $primary-color;
      background-color: $primary-color;
    }
    &--security{
      color: #0045AC;
      background-color: rgba(#0045AC, 0.1);
    }
    &--plumbing{
      color: $info;
      background-color: rgba($info, 0.1);
    }
    &--heating{
      color: $error;
      background-color: rgba($error, 0.1);
    }
    &--electrical{
      color: $warning;
      background-color: rgba($warning, 0.1);
    }
    &--neon-yellow{
      color: $neon-yellow-dark;
      background-color: $neon-yellow;
    }
    &--green {
      color: #0D725D;
      background-color: #DFF7F2;
    }
    &--blue {
      color: $vibrant-blue;
      background-color: #E8F1FC;
    }
    &--red {
      color: $cherry-red;
      background-color: #FFEBF0;
    }
    &--secondary-dark {
      color: #FFFFFF;
      background-color: $secondary-color-dark;
    }
  }

</style>
